import { useEffect } from 'react';

export default ({ onChange, value }) => {
  useEffect(() => {
    onChange && onChange(value);
  }, [value]);

  return <></>;
};
